import { useState, useCallback } from "react";
import Image from 'next/image';
import styles from './carousels.module.scss';
import Icon from '@components/Icons';
import useInterval from '@lib/useInterval';
import type { carouselImage } from '@lib/types';

/**
 * !!! THIS CAROUSEL CURENTLY ONLY WORKS WITH 3 IMAGES! NO MORE, NO LESS !!!!!
 * @param images Array of Carousel Images
 * @param auto boolean - Set if autoplay is active (default is active)
 * @param overlap top | bottom | none - string adjust margin to overlap sections
 * @returns 3D image carousel element of 3 images
 */
const CarouselThreeD = ({ images, auto = true, overlap = "none" }: {
    images: carouselImage[]
    auto?: boolean
    overlap?: string
}) => {

    // !!! THIS CAROUSEL CURENTLY ONLY WORKS WITH 3 IMAGES! NO MORE, NO LESS !!!!!

    const [positions, setPositions] = useState([
        styles.leftSlide,
        "",
        styles.rightSlide
    ]);

    const [autoPlay, setAutoPlay] = useState({
        play: auto, // activates autoplay
        time: 3000, // autoplay time
    })

    const [reset, setReset] = useState(0);

    const resetAutoPlay = useCallback(() => {
        setReset(c => c + 1)
    }, [])

    const changePositions = useCallback((left: boolean) => {
        const array = positions;
        (left) ? array.push(array.shift()!) : array.unshift(array.pop()!)
        setPositions(array);
    }, [positions])

    const moveIt = useCallback((left: boolean) => {
        changePositions(left);
        resetAutoPlay();
    }, [changePositions, resetAutoPlay])

    //Start autoplay
    useInterval(() => {
        if (autoPlay.play) moveIt(true);
    }, autoPlay.time, reset)

    return (
        <div className={`${styles.ThreeD} ${styles[overlap]}`} style={{maxHeight: `${images[0].height}px`}}>
            {images.map((image, index) => (
                <div key={index} className={`${styles.ThreeD__slide} ${positions[index]}`} style={{maxHeight: `${images[0].height}px`}}>
                    <Image
                        loading="lazy"
                        src={image.path}
                        width={image.width}
                        height={image.height}
                        alt={image.alt}
                        placeholder='blur'
                        blurDataURL={image.blurDataURL}
                        className={styles.ThreeDimg}
                        sizes={images[0].sizes}
                    />
                </div>
            ))}
            <button
                className={`${styles.embla__button} ${styles.embla__button_prev}`}
                onClick={() => {
                    moveIt(true)
                }}
            >
                <Icon iconClass="nav-arrow-left" extraClass={styles.embla__button__svg} />
            </button>
            <button
                className={`${styles.embla__button} ${styles.embla__button_next}`}
                onClick={() => {
                    moveIt(false);
                }}
            >
                <Icon iconClass="nav-arrow-right" extraClass={styles.embla__button__svg} />
            </button>
        </div>
    )
}



export default CarouselThreeD;